const fragment = `
  id
  palette {
    id
    name
    defaultImageUrl
  }
`;

export const listProjectPalettesQuery = `
  query ListProjectPalettes(
    $filter: ProjectPaletteFilterInput
  ) {
    items: listProjectPalettes(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createProjectPaletteQuery = `
  mutation CreateProjectPalette(
    $input: CreateProjectPaletteInput!
  ) {
    item: createProjectPalette(input: $input) {
      ${fragment}
    }
  }
`;

export const updateProjectPaletteQuery = `
  mutation UpdateProjectPalette(
    $input: UpdateProjectPaletteInput!
  ) {
    item: updateProjectPalette(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteProjectPaletteQuery = `
  mutation DeleteProjectPalette(
    $id: Int!
  ) {
    item: deleteProjectPalette(id: $id) {
      ${fragment}
    }
  }
`;
